import React, { Component, createRef } from 'react';

// CSS
import '../Subscriptions/Subscription.scss';
import '../Courses/Courses.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch, uploadCourseMedia } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { FileUpload } from 'primereact/fileupload';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

// Properties
const properties = require('../../properties.json');

class ShareMeta extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        ogTitle: '',
        ogDescription: '',
        ogImageUrl: '',
        name: '',
        description: '',
        image: '',
        saving: false,
        uploading: false,
        loading: true,
    }

    componentDidMount() {
        document.title = properties.site_name + " | مشاركة الرابط";
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
            return;
        }
        apiFetch("/teachers/me")
            .then(me => {
                this.setState({
                    ogTitle: me.ogTitle || '',
                    ogDescription: me.ogDescription || '',
                    ogImageUrl: me.ogImageUrl || '',
                    name: me.name || '',
                    description: me.description || '',
                    image: me.image || '',
                    loading: false,
                });
            })
            .catch(error => {
                this.setState({ loading: false });
                console.error('Error:', error);
            });
    }

    uploadShareImage = async (event) => {
        const file = event.files && event.files[0];
        if (!file) return;
        this.setState({ uploading: true });
        try {
            const url = await uploadCourseMedia(file);
            this.setState({ ogImageUrl: url, uploading: false });
            this.toast.current.show({ severity: 'info', summary: 'تم بنجاح', detail: 'تم رفع الصورة' });
        } catch (error) {
            console.error('Error:', error);
            this.setState({ uploading: false });
            this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'فشل رفع الصورة' });
        } finally {
            event.options && event.options.clear && event.options.clear();
        }
    }

    save = () => {
        const { ogTitle, ogDescription, ogImageUrl } = this.state;
        this.setState({ saving: true });
        apiFetch("/teachers/me/share-meta", { method: "PUT", body: { ogTitle, ogDescription, ogImageUrl } })
            .then(() => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'تم حفظ بيانات المشاركة' });
            })
            .catch(error => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
            });
    }

    render() {
        const { ogTitle, ogDescription, ogImageUrl, name, description, image, saving, uploading, loading } = this.state;

        return (
            <>
                <Header pageName="مشاركة الرابط" />
                <Toast ref={this.toast}></Toast>
                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card title="بيانات مشاركة الرابط">
                                {!loading &&
                                    <div className="p-col-12 p-md-8 p-m-3">
                                        <p>
                                            دي البيانات اللي هتظهر لما حد يبعت رابط موقعك (الدومين بتاعك) على{' '}
                                            <b>واتساب</b> أو <b>فيسبوك</b> أو أي مكان تاني -- سيبها فاضية لو عايز
                                            تستخدم إسم ووصف وصورة حسابك العادية ({name || 'بدون إسم'}).
                                        </p>

                                        <div className="p-col-12 p-md-12" style={{ marginTop: 16 }}>
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputText
                                                        value={ogTitle}
                                                        placeholder={name}
                                                        onChange={(e) => this.setState({ ogTitle: e.target.value })}
                                                    />
                                                    <label>عنوان المشاركة</label>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputTextarea
                                                        rows={3}
                                                        value={ogDescription}
                                                        placeholder={description}
                                                        onChange={(e) => this.setState({ ogDescription: e.target.value })}
                                                    />
                                                    <label>وصف المشاركة</label>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <FileUpload
                                                name="shareImage"
                                                customUpload
                                                uploadHandler={this.uploadShareImage}
                                                auto
                                                disabled={uploading}
                                                multiple={false}
                                                accept="image/*"
                                                maxFileSize={20000000}
                                                chooseLabel={uploading ? "جاري الرفع..." : "إختيار صورة المشاركة"}
                                                uploadLabel="رفع الصورة"
                                                cancelLabel="إلغاء"
                                                emptyTemplate={<p className="p-m-0">إسحب صورة المشاركة هنا ليبدأ التحميل</p>}
                                            />
                                            {uploading ? (
                                                <div className="upload-progress-row">
                                                    <ProgressSpinner style={{ width: "20px", height: "20px" }} strokeWidth="6" />
                                                    <span>جاري رفع الصورة، من فضلك انتظر...</span>
                                                </div>
                                            ) : null}
                                            {ogImageUrl ? (
                                                <div className="uploaded-file-row">
                                                    <img className="course-thumb-preview" src={ogImageUrl} alt="share" />
                                                    <Button
                                                        icon="pi pi-times"
                                                        className="p-button-rounded p-button-text p-button-danger"
                                                        onClick={() => this.setState({ ogImageUrl: '' })}
                                                    />
                                                </div>
                                            ) : image ? (
                                                <p>هيتم استخدام صورة حسابك الحالية لحد ما ترفع صورة تانية هنا.</p>
                                            ) : null}
                                        </div>

                                        <div className="p-col-12 p-md-12">
                                            <Button
                                                className={`add-button ${saving ? "loading" : ""}`}
                                                label={saving ? "جاري الحفظ..." : "حفظ"}
                                                disabled={saving}
                                                onClick={this.save}
                                            />
                                        </div>
                                    </div>
                                }
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ShareMeta;
